// ***************************************
// Definition of game token ReplayTransitionToken
// ***************************************
import { tbGame } from "../engine/tbGame";
import { ComponentContainer } from "../framework/components/ComponentContainer";
import { tgfGraphics } from "../framework/tgfGraphics";
import { replay_transition } from "./AssetDefinitions/SpineDefinitions";
// The constructor for the ReplayTransitionToken game token. 
export var ReplayTransitionToken = function (callback1, callback2) {
    "use strict";
    // Properties used by the engine
    this.visible = true;
    this.active = true;
    // Your own properties
    var self = this;
    this.timer = -1;
    this.interval = 25;
    this.container = new ComponentContainer({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2
    });
    this.callback = function () {
        self.active = false;
        self.transition.remove();
        tbGame.removeToken(self);
        if (callback2)
            callback2();
    };
    this.transition = replay_transition.clone();
    this.transition.setAnimation("replay_transition_fadeout", false);
    this.transition.animation.skeleton['setSlotsToSetupPose']();
    this.transition.setOnComplete(function () {
        if (callback1)
            callback1();
        self.transition.remove();
        self.transition.add();
        self.transition.setAnimation("replay_transition_fadein", false);
        self.transition.animation.skeleton['setSlotsToSetupPose']();
        self.transition.setOnComplete(function () {
            self.timer = 0;
        });
    });
    this.transition.setPosition(1366 / 2, 768 / 2);
    this.transition.setScale(1, 1);
    this.transition.add();
    // Add it to the game engine
    tbGame.addToken(this);
};
// handleAdd is called when the token is (re-) added to the game. 
ReplayTransitionToken.prototype.handleAdd = function () {
    "use strict";
    var self = this;
};
// handleRemove is called when the token is removed from the game.
ReplayTransitionToken.prototype.handleRemove = function () {
    "use strict";
};
// handleBeginStep is called each step before processing other events.
ReplayTransitionToken.prototype.handleBeginStep = function (timePassed) {
    "use strict";
    //tgfGraphics.addChild(this.transition);
    //this.transition.update(timePassed);
    //this.transition.state.update(timePassed);
    //this.transition.animation.update(timePassed);
};
// handleTouchDown is called when a touch is started or if a mouse button is pressed.
ReplayTransitionToken.prototype.handleTouchDown = function (finger, x, y) {
    "use strict";
};
// handleTouchUp is called when a touch is ended or if a mouse button is released.
ReplayTransitionToken.prototype.handleTouchUp = function (finger, x, y) {
    "use strict";
};
// handleKeyDown is called if the key with the given keyCode is pressed.
ReplayTransitionToken.prototype.handleKeyDown = function (keyCode) {
    "use strict";
};
// handleKeyUp is called if the key with the given keyCode is released.
ReplayTransitionToken.prototype.handleKeyUp = function (keyCode) {
    "use strict";
};
// handleAlarm is called if a global alarm is reached.
ReplayTransitionToken.prototype.handleAlarm = function (alarm) {
    "use strict";
};
// handleSpecial is called if a special or user-defined event happens.
ReplayTransitionToken.prototype.handleSpecial = function (id, args) {
    "use strict";
};
// handleEndStep is called each step after processing other events (before draw).
ReplayTransitionToken.prototype.handleEndStep = function (timePassed) {
    "use strict";
    if (this.active === false)
        return;
    if (this.timer >= 0) {
        this.timer++;
        if (this.timer >= this.interval) {
            this.callback();
            return;
        }
    }
    //tgfGraphics.removeChild(this.transition);
    this.transition.remove();
    this.transition.add();
};
// handleDraw is called at the end of a step to draw the token.
ReplayTransitionToken.prototype.handleDraw = function () {
    "use strict";
};
